import { switchOffLimitPaymentDataQuery } from '../../graphql/queries/grid/wallet';
import { SwitchOffLimitPaymentData } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class WalletDataProvider extends BaseDataProvider {
    public async fetchSwitchOffLimitPaymentData(login: string): Promise<SwitchOffLimitPaymentData> {
        const result = await this.createQuery<SwitchOffLimitPaymentData>(switchOffLimitPaymentDataQuery, {
            variables: {
                login
            }
        });

        return result.data;
    }
}
